import { CardstackAssignment } from 'shared/api/assignment-service';
import { CardEventHandlers } from 'shared/api/event-service';
import { StreamCard } from 'shared/ui/stream-card';
import { getClassworkClassActivitiesLink } from 'shared/lib/utils';

export type Props = {
  classLabel: string;
  assignment: CardstackAssignment;
  eventHandlers: CardEventHandlers;
};

export const CardstackAssignmentCard = ({
  classLabel,
  assignment,
  eventHandlers,
}: Props) => {
  const classworkClassActivitiesLink =
    getClassworkClassActivitiesLink(assignment);

  return (
    <StreamCard
      assignment={assignment}
      classLabel={classLabel}
      content={assignment.content[0]}
      caption={`You assigned ${assignment.content.length} ${
        assignment.content.length === 1 ? 'activity' : 'activities'
      } for`}
      eventHandlers={eventHandlers}
      startDate={assignment.startDate ?? assignment.createdDate}
      dueDate={assignment.dueDate}
      viewWorkButtonUrl={classworkClassActivitiesLink}
    />
  );
};
